import QuickAccess from '../Cards/AccessToRigths';
import QuickAccessButton from '../Cards/QuickAccessButton';
import { EvaluatedRights } from '../../interfaces/Rights';
import ResponsiveContainer from '../../layouts/ResponsiveContainer';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const AccessToRigthsMapper = ({ quickAccessToRights, initialSelectedPeriod }: { initialSelectedPeriod: string, quickAccessToRights: EvaluatedRights[] }) => {
    const [selectedPeriod, setSelectedPeriod] = useState(initialSelectedPeriod);

    useEffect(() => {
        setSelectedPeriod(initialSelectedPeriod);
    }, [initialSelectedPeriod]);

    const getEvaluatorUrl = (right: string, rightId: number) =>
        `evaluador?right=${right}&rightId=${rightId}&periodo=${Number(selectedPeriod)}`;

    const getVisualizerUrl = (right: string) =>
        `visualizador-de-indicadores?right=${right}&period=${Number(selectedPeriod)}&page=1&limit=5`;

    return (
        <ResponsiveContainer className="flex flex-wrap gap-6 pt-6">
            {quickAccessToRights?.length > 0 && quickAccessToRights.map((right) => {
                const evaluaciones = right.evaluaciones || {};
                const periodData = evaluaciones[selectedPeriod] || {}; // Datos del período seleccionado
                const { evaluacion_trivalente, suma_aritmetica } = periodData;

                const hasEvaluation = evaluacion_trivalente !== null && suma_aritmetica !== null;
                const evaluatorUrl = getEvaluatorUrl(right.titulo, right.id);
                const visualizerUrl = getVisualizerUrl(right.titulo);

                return (
                    <div key={right.id} className="w-full md:w-[26rem] lg:w-[26.75rem] xl:w-[34.5rem]">
                        <Link
                            to={hasEvaluation ? evaluatorUrl : '#'}
                            {...(hasEvaluation ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        >
                            <QuickAccess
                                id={right.id}
                                color={right.color}
                                icono={right.icono}
                                icono_base64={right.icono_base64}
                                titulo={right.titulo}
                                estado={right.estado}
                                evaluaciones={right?.evaluaciones}
                                periodSelected={selectedPeriod}
                            />
                        </Link>
                        <div className="flex flex-col gap-2 pt-2">
                            <Link
                                to={hasEvaluation ? evaluatorUrl : '#'}
                                {...(hasEvaluation ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                            >
                                <QuickAccessButton
                                    label='Evaluador'
                                    disabled={!hasEvaluation}
                                />
                            </Link>
                            <Link to={visualizerUrl} target="_blank" rel="noopener noreferrer">
                                <QuickAccessButton
                                    label='Visualizador de indicadores'
                                    disabled={false}
                                />
                            </Link>
                        </div>
                    </div>
                );
            })}
        </ResponsiveContainer>
    );
};

export default AccessToRigthsMapper;